<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { personalizeText, getColor } from '$lib/helper';

    import AccordionView from './Accordion.View.svelte';

    import type { AccordionContent } from '$lib/types/Components/Accordion/AccordionContent';
    import type { Component } from '$lib/types/Components/SharedTypes';
    import type { Language } from '$lib/types/Language';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';

    export let id = '';
    export let content: AccordionContent;
    export let childComponents: Component[] = [];
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let campaignId = '';
    export let trackingProperties: TrackingProperty[] = [];
    export let theme: Theme;
    export let language: Language = 'en';
    export let layout = DEFAULT_LAYOUT;

    const items = childComponents.map((item) => {
        const title = item.components[0];
        const body = item.components[1];

        return {
            id: item._id,
            bgColor: item.content.box.backgroundColor,
            title: {
                draft: personalizeText(
                    title.content.wysiwyg,
                    trackingProperties,
                    campaignId,
                    language,
                ),
                color: getColor(title.content.color, theme.fontColor),
                linkColor: theme.buttonBackgroundColor,
            },
            body: {
                draft: personalizeText(
                    body.content.wysiwyg,
                    trackingProperties,
                    campaignId,
                    language,
                ),
                color: getColor(body.content.color, theme.fontColor),
                linkColor: theme.buttonBackgroundColor,
            },
        };
    });
</script>

<AccordionView {id} {items} {transitionDelay} {transitionEffect} box={content.box} {layout} />
